import isObject from "./component-library116.mjs";
function isStrictComparable(value) {
  return value === value && !isObject(value);
}
export {
  isStrictComparable as default
};
